import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-team-lineup',
  standalone: true,
  templateUrl: './skeleton-team-lineup.component.html',
  imports: [],
})
export class SkeletonTeamLineupComponent {}
